import { ConnectedGroupsTable } from 'features/group/table';

export function PersonGroupsPage() {
  return <ConnectedGroupsTable type={1} />;
}
